<template>

  <div class="main-layout">
    <!-- 侧边栏导航 -->
    <aside class="sidebar">
      <div class="sidebar-header">
        <h2>PSMS系统</h2>
      </div>
      <nav class="sidebar-nav">
        <ul>
          <!-- 基础数据管理 -->
          <li class="nav-item">
            <a href="#" class="nav-link" @click.stop="toggleSubmenu('basicData')">
              <i class="nav-icon">📊</i>
              <span>基础数据管理</span>
              <i class="nav-arrow">{{ submenuOpen.basicData ? '▼' : '▶' }}</i>
            </a>
            <ul v-show="submenuOpen.basicData" class="submenu">
              <li><router-link to="/process-list">工序清单管理</router-link></li>
              <li><router-link to="/supplier">供应商管理</router-link></li>
              <li><router-link to="/supplier-role">供应商角色与权限</router-link></li>
            </ul>
          </li>

          <!-- 询报价管理 -->
          <li class="nav-item">
            <a href="#" class="nav-link" @click.stop="toggleSubmenu('quotation')">
              <i class="nav-icon">💰</i>
              <span>询报价管理</span>
              <i class="nav-arrow">{{ submenuOpen.quotation ? '▼' : '▶' }}</i>
            </a>
            <ul v-show="submenuOpen.quotation" class="submenu">
              <li><router-link to="/inquiry">询价管理</router-link></li>
              <li><router-link to="/quotation">报价管理</router-link></li>
              <li><router-link to="/negotiation">在线议价</router-link></li>
              <li><router-link to="/quotation-report">报价单报表</router-link></li>
              <li><router-link to="/winning-bid">中标管理</router-link></li>
              <li><router-link to="/file-management">文件管理</router-link></li>
            </ul>
          </li>

          <!-- 生产监控 -->
          <li class="nav-item">
            <a href="#" class="nav-link" @click.stop="toggleSubmenu('production')">
              <i class="nav-icon">🚀</i>
              <span>生产监控</span>
              <i class="nav-arrow">{{ submenuOpen.production ? '▼' : '▶' }}</i>
            </a>
            <ul v-show="submenuOpen.production" class="submenu">
              <li><router-link to="/progress-board">实时进度看板</router-link></li>
              <li><router-link to="/progress-alert">工序级进度通知与预警</router-link></li>
            </ul>
          </li>

          <!-- 报表分析 -->
          <li class="nav-item">
            <a href="#" class="nav-link" @click.stop="toggleSubmenu('report')">
              <i class="nav-icon">📈</i>
              <span>报表分析</span>
              <i class="nav-arrow">{{ submenuOpen.report ? '▼' : '▶' }}</i>
            </a>
            <ul v-show="submenuOpen.report" class="submenu">
              <li><router-link to="/supplier-kpi">KPI看板</router-link></li>
            </ul>
          </li>
        </ul>
      </nav>
    </aside>

    <!-- 主内容区域 -->
    <main class="main-content">
      <header class="content-header">
        <h1>{{ $route.meta.title || 'PSMS系统' }}</h1>
      </header>
      <section class="content-body">
        <router-view></router-view>
      </section>
    </main>
  </div>
</template>

<script>
export default {
  name: 'MainLayout',
  data () {
    return {
      submenuOpen: {
        basicData: false,
        quotation: false,
        production: false,
        report: false
      }
    }
  },
  methods: {
    toggleSubmenu (menu) {
      this.submenuOpen[menu] = !this.submenuOpen[menu]
    }
  }
}
</script>

<style scoped>
.main-layout {
  display: flex;
  height: 100vh;
  font-family: Arial, sans-serif;
}

/* 侧边栏样式 */
.sidebar {
  width: 250px;
  background-color: #2c3e50;
  color: white;
  display: flex;
  flex-direction: column;
}

.sidebar-header {
  padding: 20px;
  background-color: #34495e;
  text-align: center;
}

.sidebar-header h2 {
  margin: 0;
  font-size: 18px;
}

.sidebar-nav {
  flex: 1;
  padding: 20px 0;
}

.sidebar-nav ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.nav-item {
  margin-bottom: 5px;
}

.nav-link {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  color: white;
  text-decoration: none;
  transition: background-color 0.3s;
}

.nav-link:hover {
  background-color: #34495e;
}

.nav-icon {
  margin-right: 10px;
  font-size: 16px;
}

.nav-arrow {
  margin-left: auto;
  font-size: 12px;
}

.submenu {
  background-color: #34495e;
  padding-left: 20px;
}

.submenu li {
  padding: 8px 0;
}

.submenu a {
  color: white;
  text-decoration: none;
  display: block;
  padding: 8px 20px;
  transition: background-color 0.3s;
}

.submenu a:hover {
  background-color: #4a637b;
}

.submenu a.router-link-active {
  background-color: #3498db;
}

/* 主内容区域样式 */
.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: #f5f7fa;
  overflow: hidden;
}

.content-header {
  padding: 20px;
  background-color: white;
  border-bottom: 1px solid #e0e6ed;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.content-header h1 {
  margin: 0;
  font-size: 24px;
  color: #2c3e50;
}

.content-body {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/MainLayout.vue